export default __webpack_public_path__ + "static/media/kakemono.87f8c980.jpg";